import { NodeViewWrapper, NodeViewWrapperProps } from '@tiptap/react';
import { FC } from 'react';
import AnchorIcon from '@wix/da-ds/pkg/Icons/24x24/EditorAnchor';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';

import s from './AnchorNodeView.scss';

const AnchorNodeView: FC<NodeViewWrapperProps> = props => {
  return (
    <NodeViewWrapper data-drag-handle="true" className={s['root']} as={'span'}>
      <SimpleTooltip
        usePortal
        text={`#${props.node.attrs.id}`}
        hoverDelay={200}
        listenOnClicks={false}
      >
        <AnchorIcon />
      </SimpleTooltip>
    </NodeViewWrapper>
  );
};
AnchorNodeView.displayName = 'AnchorNodeView';

export default AnchorNodeView;
